import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { SECTIONS, SHARED_SECTIONS, NON_DIV_SECTIONS } from '@/pages/learn/learnSections';
import { TOTAL_TERMS } from '@/pages/Glossary';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const GUIDE_COUNT = [...SECTIONS, ...SHARED_SECTIONS, ...NON_DIV_SECTIONS].reduce((n, s) => n + s.posts.length, 0);

function useCountUp(target, ms = 900) {
  const [v, setV] = useState(0);
  useEffect(() => {
    if (!target) return undefined;
    let raf; const t0 = performance.now();
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / ms);
      setV(Math.round(target * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, ms]);
  return v;
}

function Stat({ value, label, to, testId }) {
  const n = useCountUp(value);
  if (!value) return null;
  return (
    <Link to={to} className="inline-flex items-baseline gap-1.5 hover:text-cyan-200 transition-colors" data-testid={testId} title={`Open ${label.toLowerCase()}`}>
      <span className="font-mono font-bold text-cyan-300 tabular-nums">{n.toLocaleString()}</span>
      <span>{label}</span>
    </Link>
  );
}

export default function LandingStatsStrip() {
  const [s, setS] = useState(null);
  useEffect(() => {
    axios.get(`${API}/public/stats`, { timeout: 10000 }).then((r) => setS(r.data || {})).catch(() => setS({}));
  }, []);
  if (!s) return null;
  const items = [
    { value: s.stocks_tracked, label: 'STOCKS TRACKED', to: '/dashboard?search=1', testId: 'lp1-stat-stocks' },
    { value: s.dividend_payers, label: 'DIVIDEND PAYERS', to: '/screener?filter=dividend', testId: 'lp1-stat-payers' },
    { value: GUIDE_COUNT, label: 'LEARN GUIDES', to: '/learn', testId: 'lp1-stat-guides' },
    { value: TOTAL_TERMS, label: 'GLOSSARY TERMS', to: '/glossary', testId: 'lp1-stat-terms' },
    { value: s.mega_tier_elite, label: 'MEGA TIER ELITE', to: '/mega-tier', testId: 'lp1-stat-elite' },
  ].filter((i) => i.value);
  if (items.length === 0) return null;
  return (
    <div
      className="mt-5 text-[10px] sm:text-xs tracking-[0.18em] sm:tracking-[0.28em] text-violet-200/75 flex flex-wrap items-center gap-x-3 gap-y-1.5"
      data-testid="lp1-stats-strip"
    >
      <span className="hidden sm:inline text-cyan-400/70">[</span>
      {items.map((it, i) => (
        <span key={it.testId} className="inline-flex items-center gap-x-3">
          <Stat {...it} />
          {i < items.length - 1 && <span className="hidden sm:inline text-cyan-400/50">▌</span>}
        </span>
      ))}
      <span className="hidden sm:inline text-cyan-400/70">]</span>
    </div>
  );
}
